
export const SET_HIDE_FOOTER = 'footer:set-hide-footer';
export const SET_SHOW_FOOTER = 'footer:set-show-footer';
export const SET_HIDE_HEADER = 'header:set-hide-header';
export const SET_SHOW_HEADER = 'header:set-show-header';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/topBottomSection/action-types.js
 **/